module.exports = __webpack_public_path__ + "img/edit.186cb5a8.svg";